import loadTableViewFromTableQuery from './loadTableViewFromTableQuery';
import { getDefaultInboxTableQuery } from 'owa-mail-triage-table-utils/lib/getDefaultInboxTableQueries';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import type { MailboxInfo } from 'owa-client-types';
import { Module } from 'owa-workloads-module';

// Function that loads the default table view.
export function loadDefaultTable(mailboxInfo: MailboxInfo, sessionData?: SessionData): void {
    // Load default inbox table
    loadTableViewFromTableQuery(
        getDefaultInboxTableQuery(mailboxInfo),
        undefined /* loadTableViewDatapoint */,
        'Route' /* actionSource */,
        sessionData,
        Module.Mail
    );
}
